export const BRAND_EDIT_MULTILINE_ROWS = 7;
